<template>
    <v-row justify="center">
        <v-dialog eager v-model="alterarIdiomadialog" max-width="290" overlay-opacity="0.5" overlay-color="black">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="!$vuetify.breakpoint.xs" outlined color="gold" v-bind="attrs" v-on="on">
                    <v-icon class="pr-2">language</v-icon>
                    SELECIONE SEU IDIOMA
                </v-btn>
                <v-btn v-else icon color="gold" v-bind="attrs" v-on="on">
                    <v-icon>language</v-icon>
                </v-btn>
                <span v-if="$vuetify.breakpoint.xs" class="c-text-idioma gold--text">IDIOMAS</span>
            </template>
            <v-card color="verdebg">
                <v-btn x-small color="goldmono" absolute right fab dark @click="alterarIdiomadialog = false"
                    class="mt-2 mr-n1 mr-sm-0">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-text class="pt-2 c-selecionar-traducao">
                    <Translator :countries="paises" @on-country-click="hideModal($event)" />
                </v-card-text>
                <!-- <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gold" outlined @click="alterarIdiomadialog = false">
                        FECHAR
                    </v-btn>
                    <v-btn color="goldmono" @click="alterarIdiomadialog = false">
                        FECHAR
                    </v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>
    </v-row>
</template>
  
<script>
import { Translator } from 'vue-google-translate';
export default {
    name: "TradutorModal-screen",
    components: { Translator },
    data: () => ({
        paises: [
            {
                code: 'en|pt',
                title: 'Português',
                flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/il.svg",
                class: "oaaab"
            },
            {
                code: "en|iw",
                title: "Hebrew",
                flagIconUrl: "https://flagicons.lipis.dev/flags/4x3/il.svg",
                altText: "Hebrew language translation",
            },
            {
                code: "en|en",
                title: "English",
            },
            {
                code: "en|es",
                title: "Spanish",
            },
            {
                code: "en|fr",
                title: "French",
            },
            {
                code: "en|de",
                title: "German",
            },
            {
                code: "en|it",
                title: "Italian",
            },
            {
                code: "en|ru",
                title: "Russian",
            },
            {
                code: "en|zh-CN",
                title: "Chinese (Simplified)",
            },
        ],
        alterarIdiomadialog: false,
    }),
    methods: {
        setIdioma(idioma) {
            // Fecha o v-dialog
            this.$emit("setIdioma", idioma);
        },
        hideModal(event) {
            /* Só vai alterar o idioma para israel caso clque na bandeira de israel, caso o contrario vai definir como Brasil */
            this.setIdioma(event)
            localStorage.setItem('userLang', event);
            this.alterarIdiomadialog = false;
        }
    },
};
</script>
  
<style>
.c-selecionar-traducao > div > div .py-2:nth-child(1) .language-item {
    background-image: url("~@/assets/brazil-.webp");
    width: 40px;
    height: 40px;
    background-size: contain;
}
.c-selecionar-traducao > div > div .py-2:nth-child(1) img {
    display: none!important;
}
.c-selecionar-traducao > div > div .py-2:nth-child(1) .language__text {
    margin-left: 45px;
}
.c-selecionar-traducao > div > div .py-2:nth-child(2) {
    margin-left: -6px;
}
.c-selecionar-traducao > div > div .py-2:nth-child(2) img {
    width: 50px;
    display: block;
    height: 40px;
    object-fit: cover;
    clip-path: circle(45% at center);
}
span.language__text {
    color: #cb972c!important;
    font-weight: 500;
}
.c-text-idioma {
    font-size: x-small;
    font-weight: 600;
    margin-top: -5px;
    text-align: center;
}
</style>